import { render } from "./VideoWatermark.vue?vue&type=template&id=213d07f0&scoped=true"
import script from "./VideoWatermark.vue?vue&type=script&lang=js"
export * from "./VideoWatermark.vue?vue&type=script&lang=js"

import "./VideoWatermark.vue?vue&type=style&index=0&id=213d07f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213d07f0"]])

export default __exports__